document.addEventListener("DOMContentLoaded", () => {
    const searchButtons = document.querySelectorAll(".wens-haelo-search-button");
  
    searchButtons.forEach(searchButton => {
      const searchId = searchButton.nextElementSibling?.dataset?.searchContainerId;
  
      if (!searchId) return;
  
      const searchContainer = document.querySelector(`[data-search-container-id="${searchId}"]`);
  
      const toggleBodyScroll = (shouldLock) => {
        document.body.style.overflow = shouldLock ? 'hidden' : 'auto';
      };
  
      if (searchButton && searchContainer) {
        searchButton.addEventListener("click", () => {
          searchContainer.style.display = "flex";
          toggleBodyScroll(true);
        });
  
        searchContainer.addEventListener("click", (event) => {
          if (event.target === searchContainer) {
            searchContainer.style.display = "none";
            toggleBodyScroll(false);
          }
        });
      }
    });
  
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        const opensearchs = document.querySelectorAll('.wens-haelo-search-container[style*="display: flex"]');
        opensearchs.forEach(search => {
          search.style.display = "none";
          document.body.style.overflow = 'auto';
        });
      }
    });
  });
  